import Vue from "vue"
import Vuex from "vuex"
import globalStore from "./global/index.js"
import auth from "@/modules/auth/store/index.js"
import dashboard from "@/modules/dashboard/store/index.js"
import products from "@/modules/products/store/index.js"
import apps from "@/modules/apps/store/index.js"
import uiEditor from "@/modules/uiEditor/store/index.js"
import templates from "@/modules/templates/store/index.js"

Vue.use(Vuex)

export default new Vuex.Store({
	strict: true,
	...globalStore,
	modules: {
		auth: {
			namespaced: true,
			...auth
		},
		dashboard: {
			namespaced: true,
			...dashboard
		},
		products: {
			namespaced: true,
			...products
		},
		apps: {
			namespaced: true,
			...apps
		},
		uiEditor: {
			namespaced: true,
			...uiEditor
		},
		templates: {
			namespaced: true,
			...templates
		}
	}
})
